import styled from "styled-components";

export const AttachmentsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
`;

export const AttachmentImage = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 5px;
  object-fit: cover;
`;


export const AttachmentContainer = styled.div`
    position: relative;
    display: inline-block;
    margin: 10px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    width: 100px; 
    height: 100px;
`;

export const RemoveIcon = styled.button`
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover {
        background: rgba(255, 0, 0, 0.8);
    }
`;

export const FullScreenImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
`;

export const FullScreenImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;